import { ExtendedAxiosRequestConfig } from "@shared/services/api/abstracts/Repository";
import { useModelService } from "@shared/services/api/hooks/useModelService";
import { UseQueryOptions } from "react-query";
import PublicBasedTTSeatPermissionsRenewalPermissionsRepository from "../repositories/PublicBasedTTSeatPermissionsRenewalPermissionsRepository";
import { PublicBasedTTSeatPermissionsRenewalPermissionsSerializer } from "../types/seating-types";

const usePublicBasedTTSeatPermissionsRenewalPermissionsService = () => {
  const repository =
    new PublicBasedTTSeatPermissionsRenewalPermissionsRepository();

  const modelService = useModelService(repository);

  const useGetPermissions = ({
    params,
    config,
    options,
  }: {
    params?: Record<string, unknown>;
    config?: ExtendedAxiosRequestConfig;
    options?: UseQueryOptions<PublicBasedTTSeatPermissionsRenewalPermissionsSerializer>;
  } = {}) => {
    return modelService.useGenericQuery<PublicBasedTTSeatPermissionsRenewalPermissionsSerializer>(
      "retrieve",
      {
        params,
        config,
        options,
      }
    );
  };

  return {
    ...modelService,
    useGetPermissions,
  };
};

export default usePublicBasedTTSeatPermissionsRenewalPermissionsService;
